import { getJson, requestJson } from './apiClient';
import {
  cleanQuery,
  normalizeList,
  pickFirst,
  toBool,
  toNumberOrNull,
  toText,
} from './proyectosInmobiliariosUtils';

const BASE_URL = '/api/admin/prospectos';

export const TIPOS_PROSPECTO_CRM = [
  'INTERES_ESPECIFICO',
  'BUSQUEDA_ACTIVA',
  'INVERSIONISTA',
  'CAPTACION_PROPIETARIO',
  'OTRO',
];

export const ESTATUS_PROSPECTO_CRM = [
  'NUEVO',
  'PRIMER_CONTACTO_PENDIENTE',
  'CONTACTADO',
  'EN_SEGUIMIENTO',
  'CITA_AGENDADA',
  'VISITO_PROPIEDAD',
  'DOCUMENTACION_CREDITO',
  'OPCIONES_ENVIADAS',
  'APARTADO',
  'CIERRE',
  'NO_INTERESADO',
  'NO_LOCALIZABLE',
  'SEGUIMIENTO_FUTURO',
];

export const TEMPERATURAS_PROSPECTO = ['FRIO', 'TIBIO', 'CALIENTE'];

export const ORIGENES_PROSPECTO = [
  'SITIO_WEB',
  'FACEBOOK',
  'INSTAGRAM',
  'TIKTOK',
  'WHATSAPP',
  'LLAMADA',
  'REFERIDO',
  'VISITA_FISICA',
  'VOLANTEO',
  'PORTAL_INMOBILIARIO',
  'CAPTURA_MANUAL',
  'OTRO',
];

export const TIPOS_ACTIVIDAD_PROSPECTO = [
  'NOTA',
  'LLAMADA',
  'WHATSAPP',
  'CORREO',
  'VISITA',
  'CITA',
  'DOCUMENTO',
  'OTRO',
];

export const ESTATUS_OPCION_PROSPECTO = [
  'SUGERIDA',
  'ENVIADA',
  'LE_INTERESO',
  'SOLICITA_VISITA',
  'DESCARTADA',
  'NO_LE_INTERESO',
  'APARTADA',
  'COMPRADA',
];

export const TIPO_PROSPECTO_LABELS = {
  INTERES_ESPECIFICO: 'Interes especifico',
  BUSQUEDA_ACTIVA: 'Busqueda activa',
  INVERSIONISTA: 'Inversionista',
  CAPTACION_PROPIETARIO: 'Captacion propietario',
  OTRO: 'Otro',
};

export const ESTATUS_PROSPECTO_LABELS = {
  NUEVO: 'Nuevo',
  PRIMER_CONTACTO_PENDIENTE: 'Primer contacto pendiente',
  CONTACTADO: 'Contactado',
  EN_SEGUIMIENTO: 'En seguimiento',
  CITA_AGENDADA: 'Cita agendada',
  VISITO_PROPIEDAD: 'Visito propiedad',
  DOCUMENTACION_CREDITO: 'Documentacion / credito',
  OPCIONES_ENVIADAS: 'Opciones enviadas',
  APARTADO: 'Apartado',
  CIERRE: 'Cierre',
  NO_INTERESADO: 'No interesado',
  NO_LOCALIZABLE: 'No localizable',
  SEGUIMIENTO_FUTURO: 'Seguimiento futuro',
};

export const TEMPERATURA_LABELS = {
  FRIO: 'Frio',
  TIBIO: 'Tibio',
  CALIENTE: 'Caliente',
};

export const ORIGEN_LABELS = {
  SITIO_WEB: 'Sitio web',
  FACEBOOK: 'Facebook',
  INSTAGRAM: 'Instagram',
  TIKTOK: 'TikTok',
  WHATSAPP: 'WhatsApp',
  LLAMADA: 'Llamada',
  REFERIDO: 'Referido',
  VISITA_FISICA: 'Visita fisica',
  VOLANTEO: 'Volanteo',
  PORTAL_INMOBILIARIO: 'Portal inmobiliario',
  CAPTURA_MANUAL: 'Captura manual',
  OTRO: 'Otro',
};

export const FUENTE_TIPO_LABELS = {
  CRM_MANUAL: 'Captura manual CRM',
  INMUEBLE_PUBLICO: 'Formulario de inmueble',
  DESARROLLO_PUBLICO: 'Formulario de desarrollo',
  PROYECTO_PUBLICO: 'Formulario de proyecto',
  REFERIDO: 'Referido',
  IMPORTACION: 'Importacion',
  OTRO: 'Otro',
};

export const ACTIVIDAD_LABELS = {
  NOTA: 'Nota',
  LLAMADA: 'Llamada',
  WHATSAPP: 'WhatsApp',
  CORREO: 'Correo',
  VISITA: 'Visita',
  CITA: 'Cita',
  DOCUMENTO: 'Documento',
  OTRO: 'Otro',
};

export const ESTATUS_OPCION_LABELS = {
  SUGERIDA: 'Sugerida',
  ENVIADA: 'Enviada',
  LE_INTERESO: 'Le intereso',
  SOLICITA_VISITA: 'Solicita visita',
  DESCARTADA: 'Descartada',
  NO_LE_INTERESO: 'No le intereso',
  APARTADA: 'Apartada',
  COMPRADA: 'Comprada',
};

export const OPERACIONES_BUSQUEDA = ['COMPRA', 'RENTA', 'INVERSION', 'VENTA', 'VENTA_RENTA'];
export const TIPOS_INMUEBLE_BUSQUEDA = ['CASA', 'DEPARTAMENTO', 'TERRENO', 'LOCAL_COMERCIAL', 'OFICINA', 'BODEGA', 'OTRO'];
export const FINANCIAMIENTOS = ['CONTADO', 'INFONAVIT', 'COFINAVIT', 'FOVISSSTE', 'BANCARIO', 'MIXTO', 'SIN_DEFINIR', 'OTRO'];
export const ESTATUS_CREDITO = ['AUTORIZADO', 'EN_TRAMITE', 'NO_INICIADO', 'NO_APLICA'];

export const FINANCIAMIENTO_LABELS = {
  CONTADO: 'Efectivo / contado',
  INFONAVIT: 'Credito INFONAVIT',
  COFINAVIT: 'Credito COFINAVIT',
  FOVISSSTE: 'Credito FOVISSSTE',
  BANCARIO: 'Credito bancario',
  MIXTO: 'Credito mixto',
  SIN_DEFINIR: 'Sin definir',
  OTRO: 'Otro',
};

export const labelFromMap = (map, value, fallback = 'Sin definir') => {
  const key = toText(value).toUpperCase();
  return map[key] || (key ? key.replace(/_/g, ' ').toLowerCase().replace(/(^|\s)\S/g, (letter) => letter.toUpperCase()) : fallback);
};

export const formatDateTime = (value, fallback = 'Sin fecha') => {
  if (!value) return fallback;
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return String(value);
  return new Intl.DateTimeFormat('es-MX', {
    dateStyle: 'medium',
    timeStyle: 'short',
  }).format(date);
};

export const formatDate = (value, fallback = 'Sin fecha') => {
  if (!value) return fallback;
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return String(value);
  return new Intl.DateTimeFormat('es-MX', { dateStyle: 'medium' }).format(date);
};

export const formatCurrency = (value) => {
  if (value === null || value === undefined || value === '' || Number.isNaN(Number(value))) {
    return '';
  }

  return new Intl.NumberFormat('es-MX', {
    style: 'currency',
    currency: 'MXN',
    maximumFractionDigits: 0,
  }).format(Number(value));
};

export const isPastDate = (value) => {
  if (!value) return false;
  const date = new Date(value);
  return !Number.isNaN(date.getTime()) && date.getTime() < Date.now();
};

const normalizeCode = (value, fallback = '') => toText(value, fallback).toUpperCase();

const toNumberOrUndefined = (value) => {
  const number = toNumberOrNull(value);
  return number === null ? undefined : number;
};

const normalizeFinanciamiento = (value) => {
  const key = normalizeCode(value);

  switch (key) {
    case 'CREDITO_BANCARIO':
    case 'CREDITO BANCARIO':
      return 'BANCARIO';
    case 'CREDITO_INFONAVIT':
    case 'CREDITO INFONAVIT':
      return 'INFONAVIT';
    case 'CREDITO_FOVISSSTE':
    case 'CREDITO FOVISSSTE':
      return 'FOVISSSTE';
    default:
      return key;
  }
};

const adaptResponsableCrm = (item = {}) => ({
  id: Number(pickFirst(item.id, item.usuarioId, item.UserId)),
  nombre: toText(pickFirst(item.nombre, item.nombreCompleto, item.email), 'Sin nombre'),
  rol: normalizeCode(item.rol),
});

const filtrarResponsablesPorRol = (items, rol) =>
  normalizeList(items)
    .map(adaptResponsableCrm)
    .filter((item) => Number.isFinite(item.id) && item.rol === rol);

const fullName = (item = {}) =>
  [
    pickFirst(item.nombre, item.nombreProspecto, item.clienteNombre),
    pickFirst(item.apellidoPaterno, item.primerApellido),
    pickFirst(item.apellidoMaterno, item.segundoApellido),
  ].map((part) => toText(part)).filter(Boolean).join(' ') || toText(item.nombreCompleto, 'Sin nombre');

export const getProspectoInteres = (item = {}) => {
  const related = pickFirst(
    item.inmuebleTitulo,
    item.tituloInmueble,
    item.inmuebleNombre,
    item.desarrolloNombre,
    item.proyectoNombre,
    item.proyectoInmobiliarioNombre,
    item.modeloNombre,
    item.unidadCodigo,
    item.unidadNombre,
    item.relacionNombre,
    item.interesNombre
  );

  if (related) return toText(related);

  const tipo = normalizeCode(pickFirst(item.tipoProspecto, item.tipo));
  const busqueda = [
    pickFirst(item.tipoInmuebleBuscado, item.tipoInmueble),
    pickFirst(item.tipoOperacionBuscada, item.operacionBuscada),
    pickFirst(item.zonaInteres, item.zonaBuscada, item.ubicacionBuscada),
  ].map((part) => labelFromMap({}, part, '')).filter(Boolean).join('  ');

  if (['BUSQUEDA_ACTIVA', 'INVERSIONISTA', 'CAPTACION_PROPIETARIO'].includes(tipo) && busqueda) {
    return busqueda;
  }

  return 'Sin interes definido';
};

export const adaptProspectoListado = (item = {}) => {
  const id = toText(pickFirst(item.prospectoCrmId, item.prospectoId, item.id, item.Id));
  const asesorResponsableId = toText(pickFirst(
    item.asesorResponsableId,
    item.asesorId,
    item.responsableId,
    item.usuarioResponsableId
  ));
  const asesorResponsableNombre = toText(pickFirst(
    item.asesorResponsableNombre,
    item.asesorNombre,
    item.responsableNombre,
    item.usuarioResponsableNombre
  ));
  const fechaProximoSeguimientoRaw = pickFirst(
    item.fechaProximoSeguimiento,
    item.proximoSeguimiento,
    item.siguienteSeguimiento,
    item.fechaSeguimiento
  );
  const fechaUltimaActividadRaw = pickFirst(item.fechaUltimaActividad, item.ultimaActividadFecha, item.fechaUltimoContacto);

  return {
    raw: item,
    id,
    prospectoCrmId: toText(pickFirst(item.prospectoCrmId, id)),
    fuenteTipo: normalizeCode(pickFirst(item.fuenteTipo, item.tipoFuente), ''),
    fuenteRegistroLegacyId: toText(item.fuenteRegistroLegacyId),
    codigoReferido: toText(item.codigoReferido),
    prospectoId: id,
    nombre: fullName(item),
    nombreContacto: toText(pickFirst(item.nombre, item.nombreProspecto)),
    apellidoPaterno: toText(item.apellidoPaterno),
    apellidoMaterno: toText(item.apellidoMaterno),
    telefono: toText(pickFirst(item.telefono, item.telefonoLocal, item.celular, item.whatsapp)),
    telefonoNormalizado: toText(pickFirst(item.telefonoNormalizado, item.telefonoE164, item.whatsappNormalizado, item.whatsapp)),
    email: toText(pickFirst(item.email, item.correo)),
    tipoProspecto: normalizeCode(pickFirst(item.tipoProspecto, item.tipo), 'INTERES_ESPECIFICO'),
    origen: normalizeCode(pickFirst(item.origen, item.canal), 'OTRO'),
    origenDetalle: toText(pickFirst(item.origenDetalle, item.detalleOrigen)),
    estatus: normalizeCode(pickFirst(item.estatus, item.status, item.estado), 'NUEVO'),
    temperatura: normalizeCode(pickFirst(item.temperatura, item.nivelInteres), 'TIBIO'),
    asesorAtribucionId: toText(item.asesorAtribucionId),
    asesorAtribucionNombre: toText(item.asesorAtribucionNombre),
    asesorResponsableId,
    asesorResponsableNombre,
    asesorId: asesorResponsableId,
    asesorNombre: asesorResponsableNombre,
    supervisorId: toText(item.supervisorId),
    supervisorNombre: toText(item.supervisorNombre),
    empresaId: toText(item.empresaId),
    empresaNombre: toText(item.empresaNombre),
    interes: getProspectoInteres(item),
    inmuebleId: toText(item.inmuebleId),
    inmuebleNombre: toText(pickFirst(item.inmuebleNombre, item.inmuebleTitulo, item.tituloInmueble)),
    desarrolloId: toText(item.desarrolloId),
    desarrolloNombre: toText(item.desarrolloNombre),
    proyectoId: toText(pickFirst(item.proyectoId, item.proyectoInmobiliarioId)),
    proyectoNombre: toText(pickFirst(item.proyectoNombre, item.proyectoInmobiliarioNombre)),
    modeloId: toText(item.modeloId),
    modeloNombre: toText(item.modeloNombre),
    unidadId: toText(item.unidadId),
    unidadCodigo: toText(pickFirst(item.unidadCodigo, item.codigoUnidad)),
    fechaRegistroRaw: pickFirst(item.fechaRegistro, item.fechaCreacion, item.createdAt),
    fechaRegistro: formatDateTime(pickFirst(item.fechaRegistro, item.fechaCreacion, item.createdAt)),
    fechaProximoSeguimientoRaw,
    fechaProximoSeguimiento: formatDateTime(fechaProximoSeguimientoRaw, 'Sin seguimiento programado'),
    seguimientoVencido: toBool(item.seguimientoVencido, isPastDate(fechaProximoSeguimientoRaw)),
    fechaUltimaActividadRaw,
    fechaUltimaActividad: formatDateTime(fechaUltimaActividadRaw, 'Sin actividad'),
    tipoUltimaActividad: normalizeCode(pickFirst(item.tipoUltimaActividad, item.ultimaActividadTipo)),
    tieneDuplicados: toBool(pickFirst(item.tieneDuplicados, item.posibleDuplicado, item.esDuplicado), false),
  };
};

export const adaptProspectoDetalle = (item = {}) => ({
  ...adaptProspectoListado(item),
  codigoNumeroPaisId: toText(item.codigoNumeroPaisId),
  medioContactoPreferido: toText(pickFirst(item.medioContactoPreferido, item.contactoPreferido)),
  mensajeInicial: toText(pickFirst(item.mensajeInicial, item.mensaje, item.interesEspecifico)),
  tipoOperacionBuscada: normalizeCode(pickFirst(item.tipoOperacionBuscada, item.operacionBuscada)),
  tipoInmuebleBuscado: normalizeCode(pickFirst(item.tipoInmuebleBuscado, item.tipoInmueble)),
  zonaInteres: toText(pickFirst(item.zonaInteres, item.zonaBuscada, item.ubicacionBuscada)),
  zonasAlternativas: toText(item.zonasAlternativas),
  presupuestoMinimo: pickFirst(item.presupuestoMinimo, item.presupuestoMin),
  presupuestoMaximo: pickFirst(item.presupuestoMaximo, item.presupuestoMax),
  engancheDisponible: pickFirst(item.engancheDisponible, item.enganche),
  tipoFinanciamiento: normalizeFinanciamiento(pickFirst(item.tipoFinanciamiento, item.financiamiento)),
  estatusCredito: normalizeCode(item.estatusCredito),
  montoCredito: pickFirst(item.montoCredito, item.creditoMonto),
  institucionCredito: toText(item.institucionCredito),
  recamarasMinimas: pickFirst(item.recamarasMinimas, item.recamarasMin),
  banosMinimos: pickFirst(item.banosMinimos, item.banosMin),
  estacionamientosMinimos: pickFirst(item.estacionamientosMinimos, item.estacionamientosMin),
  superficieTerrenoMinima: pickFirst(item.superficieTerrenoMinima, item.terrenoMinimo, item.terrenoMinimoM2),
  superficieConstruccionMinima: pickFirst(item.superficieConstruccionMinima, item.construccionMinima, item.construccionMinimaM2),
  aceptaUsado: toBool(item.aceptaUsado, false),
  aceptaPreventa: toBool(item.aceptaPreventa, false),
  aceptaMunicipiosCercanos: toBool(item.aceptaMunicipiosCercanos, false),
  fechaEstimadaCompra: toText(item.fechaEstimadaCompra),
  requisitosBusqueda: toText(item.requisitosBusqueda),
  captacionTipoOperacion: normalizeCode(pickFirst(item.captacionTipoOperacion, item.tipoOperacionCaptacion)),
  captacionTipoInmueble: normalizeCode(pickFirst(item.captacionTipoInmueble, item.tipoInmuebleCaptacion)),
  captacionUbicacion: toText(pickFirst(item.captacionUbicacion, item.ubicacionPropiedad)),
  captacionDescripcion: toText(pickFirst(item.captacionDescripcion, item.descripcionPropiedad)),
  captacionPrecioEstimado: pickFirst(item.captacionPrecioEstimado, item.precioEstimado),
  motivoPerdida: toText(item.motivoPerdida),
});

export const adaptActividad = (item = {}) => ({
  raw: item,
  id: toText(pickFirst(item.actividadId, item.prospectoActividadId, item.id, item.Id)),
  tipoActividad: normalizeCode(pickFirst(item.tipoActividad, item.tipo), 'NOTA'),
  comentario: toText(pickFirst(item.comentario, item.nota, item.descripcion), 'Sin comentario'),
  usuarioNombre: toText(pickFirst(item.usuarioNombre, item.createdBy, item.asesorNombre), 'Sistema'),
  fechaRaw: pickFirst(item.fechaActividad, item.fechaCreacion, item.createdAt, item.fecha),
  fecha: formatDateTime(pickFirst(item.fechaActividad, item.fechaCreacion, item.createdAt, item.fecha)),
  estatusAnterior: normalizeCode(item.estatusAnterior),
  estatusNuevo: normalizeCode(pickFirst(item.estatusNuevo, item.nuevoEstatus)),
  temperaturaAnterior: normalizeCode(item.temperaturaAnterior),
  temperaturaNueva: normalizeCode(pickFirst(item.temperaturaNueva, item.nuevaTemperatura)),
  asesorAnteriorNombre: toText(item.asesorAnteriorNombre),
  asesorNuevoNombre: toText(item.asesorNuevoNombre),
  fechaProximoSeguimiento: formatDateTime(pickFirst(item.fechaProximoSeguimiento, item.nuevaFechaSeguimiento), ''),
});

export const adaptOpcion = (item = {}) => ({
  raw: item,
  id: toText(pickFirst(item.opcionId, item.prospectoOpcionId, item.id, item.Id)),
  tipoReferencia: normalizeCode(pickFirst(item.tipoReferencia, item.tipoOpcion, item.tipo), 'INMUEBLE'),
  estatus: normalizeCode(pickFirst(item.estatus, item.status), 'SUGERIDA'),
  comentarios: toText(pickFirst(item.comentarios, item.comentario, item.notas)),
  nombre: toText(pickFirst(
    item.nombre,
    item.titulo,
    item.inmuebleTitulo,
    item.inmuebleNombre,
    item.desarrolloNombre,
    item.proyectoNombre,
    item.modeloNombre,
    item.unidadCodigo
  ), 'Opcion inmobiliaria'),
  inmuebleId: toText(item.inmuebleId),
  desarrolloId: toText(item.desarrolloId),
  proyectoId: toText(pickFirst(item.proyectoId, item.proyectoInmobiliarioId)),
  modeloId: toText(item.modeloId),
  unidadId: toText(item.unidadId),
  fechaSugerida: formatDateTime(pickFirst(item.fechaSugerida, item.fechaCreacion, item.createdAt)),
  fechaActualizacion: formatDateTime(pickFirst(item.fechaActualizacion, item.updatedAt), ''),
});

export const adaptDuplicado = (item = {}) => ({
  raw: item,
  id: toText(pickFirst(item.prospectoId, item.id, item.Id)),
  nombre: fullName(item),
  telefono: toText(pickFirst(item.telefono, item.telefonoNormalizado, item.celular)),
  email: toText(pickFirst(item.email, item.correo)),
  asesorNombre: toText(pickFirst(item.asesorNombre, item.responsableNombre), 'Sin asignar'),
  estatus: normalizeCode(pickFirst(item.estatus, item.status), 'NUEVO'),
  fechaCreacion: formatDateTime(pickFirst(item.fechaCreacion, item.createdAt, item.fechaRegistro)),
});

export const adaptPendientes = (data = {}) => ({
  nuevosSinAtender: Number(pickFirst(data.nuevosSinAtender, data.nuevos, data.totalNuevosSinAtender, 0)) || 0,
  seguimientosVencidos: Number(pickFirst(data.seguimientosVencidos, data.vencidos, data.totalSeguimientosVencidos, 0)) || 0,
  seguimientosHoy: Number(pickFirst(data.seguimientosHoy, data.hoy, data.totalSeguimientosHoy, 0)) || 0,
  calientesSinActividad: Number(pickFirst(data.calientesSinActividad, data.prospectosCalientesSinActividad, 0)) || 0,
  actividadesProximas: Number(pickFirst(data.actividadesProximas, data.citasProximas, data.proximas, 0)) || 0,
  raw: data,
});

export const adaptRespuestaPaginada = (data = {}) => ({
  items: normalizeList(pickFirst(data.items, data.data, data.resultados, data.prospectos, data)).map(adaptProspectoListado),
  pagina: Number(pickFirst(data.pagina, data.page, 1)) || 1,
  tamanoPagina: Number(pickFirst(data.tamanoPagina, data.pageSize, 20)) || 20,
  totalRegistros: Number(pickFirst(data.totalRegistros, data.total, data.totalItems, normalizeList(data).length)) || 0,
  totalPaginas: Number(pickFirst(data.totalPaginas, data.totalPages, 1)) || 1,
});

const cleanPayload = (payload = {}) =>
  Object.fromEntries(
    Object.entries(payload).filter(([, value]) => value !== undefined && value !== '')
  );

const cleanCreatePayload = (payload = {}) =>
  Object.fromEntries(
    Object.entries(payload).filter(([, value]) => value !== undefined && value !== null && value !== '')
  );

export const listarProspectosCrm = async (filtros = {}) => {
  const { signal, ...query } = filtros;
  const data = await getJson(BASE_URL, {
    signal,
    query: cleanQuery(query),
  });
  return adaptRespuestaPaginada(data);
};

export const obtenerPendientesProspectos = async (options = {}) =>
  adaptPendientes(await getJson(`${BASE_URL}/mis-pendientes`, options));

export const getCatalogoResponsables = async (options = {}) => {
  const data = await getJson(`${BASE_URL}/catalogos/responsables`, options);

  return {
    asesores: filtrarResponsablesPorRol(data?.asesores, 'ASESOR'),
    supervisores: filtrarResponsablesPorRol(data?.supervisores, 'SUPERVISOR'),
  };
};

export const validarDuplicadosProspecto = async (payload, options = {}) => {
  const data = await requestJson(`${BASE_URL}/validar-duplicados`, {
    method: 'POST',
    body: cleanPayload({
      telefono: toText(payload.telefono) || null,
      codigoNumeroPaisId: toNumberOrNull(payload.codigoNumeroPaisId),
      email: toText(payload.email) || null,
      excluirProspectoId: toNumberOrNull(payload.excluirProspectoId),
    }),
    ...options,
  });
  return normalizeList(pickFirst(data.coincidencias, data.duplicados, data.items, data.data, data)).map(adaptDuplicado);
};

export const crearProspectoCrm = async (payload) => {
  const data = await requestJson(BASE_URL, { method: 'POST', body: cleanCreatePayload(payload) });
  return adaptProspectoDetalle(pickFirst(data.prospecto, data.data, data));
};

export const obtenerProspectoCrm = async (id, options = {}) =>
  adaptProspectoDetalle(await getJson(`${BASE_URL}/${id}`, options));

export const actualizarProspectoCrm = async (id, payload) =>
  adaptProspectoDetalle(await requestJson(`${BASE_URL}/${id}`, {
    method: 'PUT',
    body: cleanPayload(payload),
  }));

export const cambiarEstatusProspectoCrm = (id, payload) =>
  requestJson(`${BASE_URL}/${id}/estatus`, { method: 'PATCH', body: cleanPayload(payload) });

export const cambiarTemperaturaProspectoCrm = (id, payload) =>
  requestJson(`${BASE_URL}/${id}/temperatura`, { method: 'PATCH', body: cleanPayload(payload) });

export const reasignarProspectoCrm = (id, payload) =>
  requestJson(`${BASE_URL}/${id}/asignacion`, { method: 'PATCH', body: cleanPayload(payload) });

export const listarActividadesProspecto = async (id, options = {}) =>
  normalizeList(await getJson(`${BASE_URL}/${id}/actividades`, options)).map(adaptActividad);

export const crearActividadProspecto = (id, payload) =>
  requestJson(`${BASE_URL}/${id}/actividades`, { method: 'POST', body: cleanPayload(payload) });

export const crearOpcionProspecto = (id, payload) =>
  requestJson(`${BASE_URL}/${id}/opciones`, { method: 'POST', body: cleanPayload(payload) });

export const actualizarOpcionProspecto = (id, opcionId, payload) =>
  requestJson(`${BASE_URL}/${id}/opciones/${opcionId}`, { method: 'PATCH', body: cleanPayload(payload) });

export const eliminarOpcionProspecto = (id, opcionId) =>
  requestJson(`${BASE_URL}/${id}/opciones/${opcionId}`, { method: 'DELETE' });

export const normalizeProspectoPayload = (form = {}) => ({
  tipoProspecto: normalizeCode(form.tipoProspecto, 'INTERES_ESPECIFICO'),
  nombre: toText(form.nombre),
  apellidoPaterno: toText(form.apellidoPaterno) || null,
  apellidoMaterno: toText(form.apellidoMaterno) || null,
  codigoNumeroPaisId: toNumberOrNull(form.codigoNumeroPaisId),
  telefono: toText(form.telefono) || null,
  email: toText(form.email) || null,
  medioContactoPreferido: toText(form.medioContactoPreferido) || null,
  origen: 'CAPTURA_MANUAL',
  origenDetalle: toText(form.origenDetalle) || null,
  inmuebleId: toNumberOrNull(form.inmuebleId),
  desarrolloId: toNumberOrNull(form.desarrolloId),
  proyectoId: toNumberOrNull(form.proyectoId),
  modeloId: toNumberOrNull(form.modeloId),
  unidadId: toNumberOrNull(form.unidadId),
  mensajeInicial: toText(form.mensajeInicial) || null,
  tipoOperacionBuscada: normalizeCode(form.tipoOperacionBuscada) || null,
  tipoInmuebleBuscado: normalizeCode(form.tipoInmuebleBuscado) || null,
  zonaInteres: toText(form.zonaInteres) || null,
  zonasAlternativas: toText(form.zonasAlternativas) || null,
  presupuestoMinimo: toNumberOrNull(form.presupuestoMinimo),
  presupuestoMaximo: toNumberOrNull(form.presupuestoMaximo),
  engancheDisponible: toNumberOrNull(form.engancheDisponible),
  tipoFinanciamiento: normalizeFinanciamiento(form.tipoFinanciamiento) || null,
  estatusCredito: normalizeCode(form.estatusCredito) || null,
  montoCredito: toNumberOrNull(form.montoCredito),
  institucionCredito: toText(form.institucionCredito) || null,
  recamarasMinimas: toNumberOrNull(form.recamarasMinimas),
  banosMinimos: toNumberOrNull(form.banosMinimos),
  estacionamientosMinimos: toNumberOrNull(form.estacionamientosMinimos),
  superficieTerrenoMinima: toNumberOrUndefined(form.superficieTerrenoMinima),
  superficieConstruccionMinima: toNumberOrUndefined(form.superficieConstruccionMinima),
  aceptaUsado: form.aceptaUsado === true,
  aceptaPreventa: form.aceptaPreventa === true,
  aceptaMunicipiosCercanos: form.aceptaMunicipiosCercanos === true,
  fechaEstimadaCompra: toText(form.fechaEstimadaCompra) || null,
  requisitosBusqueda: toText(form.requisitosBusqueda) || null,
  captacionTipoOperacion: normalizeCode(form.captacionTipoOperacion) || null,
  captacionTipoInmueble: normalizeCode(form.captacionTipoInmueble) || null,
  captacionUbicacion: toText(form.captacionUbicacion) || null,
  captacionDescripcion: toText(form.captacionDescripcion) || null,
  captacionPrecioEstimado: toNumberOrNull(form.captacionPrecioEstimado),
  estatus: normalizeCode(form.estatus, 'NUEVO'),
  temperatura: normalizeCode(form.temperatura, 'TIBIO'),
  fechaProximoSeguimiento: toText(form.fechaProximoSeguimiento) || null,
  asesorId: toNumberOrNull(form.asesorId),
  supervisorId: toNumberOrNull(form.supervisorId),
});
